import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "table-auto text-center align-middle w-full" }
const _hoisted_2 = { class: "bg-brown-gradient text-white text-xl leading-[24px] font-semibold" }
const _hoisted_3 = { class: "h-12" }
const _hoisted_4 = { class: "w-1/4" }
const _hoisted_5 = { class: "w-1/4" }
const _hoisted_6 = { class: "w-1/4" }
const _hoisted_7 = { class: "w-1/4" }
const _hoisted_8 = { class: "max-w-96" }
const _hoisted_9 = { class: "text-left" }
const _hoisted_10 = { class: "text-brown" }
const _hoisted_11 = { class: "max-w-96" }
const _hoisted_12 = { class: "text-left" }
const _hoisted_13 = { class: "max-w-96" }
const _hoisted_14 = { class: "text-left" }
const _hoisted_15 = ["src", "alt"]
const _hoisted_16 = { class: "max-w-96 text-left" }
const _hoisted_17 = { class: "max-w-96" }
const _hoisted_18 = { class: "text-left" }


import AppTooltip from "@/components/AppTooltip.vue";
import { Pillar } from "@/types/calculators";
import { elColor } from "@/constants/colors";
import { elementStageNames, tenGods, ownerOrder } from "@/constants/bazi";
import { useI18n } from "vue-i18n";


export default /*@__PURE__*/_defineComponent({
  __name: 'NatalBirthdayDecktop',
  props: {
    pillars: {}
  },
  setup(__props: any) {



const { t } = useI18n();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("table", _hoisted_1, [
    _createElementVNode("thead", _hoisted_2, [
      _createElementVNode("tr", _hoisted_3, [
        _createElementVNode("th", _hoisted_4, _toDisplayString(_unref(t)("calculators.bazi.results.birthday-map.times.hour")), 1),
        _createElementVNode("th", _hoisted_5, _toDisplayString(_unref(t)("calculators.bazi.results.birthday-map.times.day")), 1),
        _createElementVNode("th", _hoisted_6, _toDisplayString(_unref(t)("calculators.bazi.results.birthday-map.times.month")), 1),
        _createElementVNode("th", _hoisted_7, _toDisplayString(_unref(t)("calculators.bazi.results.birthday-map.times.year")), 1)
      ])
    ]),
    _createElementVNode("tbody", null, [
      _createElementVNode("tr", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(ownerOrder), (key) => {
          return (_openBlock(), _createElementBlock("td", {
            key: key,
            class: "border px-3 py-3 align-middle"
          }, [
            _createElementVNode("p", null, _toDisplayString(_unref(t)("calculators.bazi.results.birthday-map.stem.heaven-stem")), 1),
            _createVNode(AppTooltip, null, {
              trigger: _withCtx(() => [
                _createElementVNode("h4", {
                  class: _normalizeClass(_unref(elColor)[__props.pillars[key].element])
                }, _toDisplayString(__props.pillars[key].stem), 3)
              ]),
              popper: _withCtx(() => [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("h5", null, _toDisplayString(__props.pillars[key].labels.stem), 1),
                  _createElementVNode("div", _hoisted_9, _toDisplayString(__props.pillars[key].tips.stem), 1)
                ])
              ]),
              _: 2
            }, 1024)
          ]))
        }), 128))
      ]),
      _createElementVNode("tr", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(ownerOrder), (key) => {
          return (_openBlock(), _createElementBlock("td", {
            key: key,
            class: "border px-3 py-3 align-middle"
          }, [
            _createElementVNode("p", null, _toDisplayString(_unref(t)("calculators.bazi.results.birthday-map.stem.earth-branch")), 1),
            _createVNode(AppTooltip, null, {
              trigger: _withCtx(() => [
                _createElementVNode("h4", _hoisted_10, _toDisplayString(__props.pillars[key].branch), 1)
              ]),
              popper: _withCtx(() => [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("h5", null, _toDisplayString(__props.pillars[key].labels.branch), 1),
                  _createElementVNode("div", _hoisted_12, _toDisplayString(__props.pillars[key].tips.branch), 1)
                ])
              ]),
              _: 2
            }, 1024)
          ]))
        }), 128))
      ]),
      _createElementVNode("tr", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(ownerOrder), (key) => {
          return (_openBlock(), _createElementBlock("td", {
            key: key,
            class: "border px-3 py-3 align-middle"
          }, [
            _createElementVNode("p", null, _toDisplayString(_unref(t)("calculators.bazi.results.birthday-map.stem.stage")), 1),
            _createVNode(AppTooltip, null, {
              trigger: _withCtx(() => [
                _createElementVNode("h4", {
                  class: "mb-0",
                  style: _normalizeStyle(`color: ${
                  _unref(elementStageNames)[__props.pillars[key].stage]['color']
                }`)
                }, _toDisplayString(__props.pillars[key].stage), 5)
              ]),
              popper: _withCtx(() => [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("h5", null, _toDisplayString(__props.pillars[key].labels.stage), 1),
                  _createElementVNode("div", _hoisted_14, _toDisplayString(__props.pillars[key].tips.stage), 1)
                ])
              ]),
              _: 2
            }, 1024)
          ]))
        }), 128))
      ]),
      _createElementVNode("tr", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(ownerOrder), (key) => {
          return (_openBlock(), _createElementBlock("td", {
            key: key,
            class: "border px-2 py-2 align-middle"
          }, [
            _createElementVNode("p", null, _toDisplayString(_unref(t)("calculators.bazi.results.birthday-map.stem.element")), 1),
            _createVNode(AppTooltip, null, {
              trigger: _withCtx(() => [
                _createElementVNode("img", {
                  src: 
                  require(`@/assets/calculators/bazi/${__props.pillars[key].element}.png`)
                ,
                  alt: __props.pillars[key].element,
                  class: "my-1 size-10 mx-auto"
                }, null, 8, _hoisted_15)
              ]),
              popper: _withCtx(() => [
                _createElementVNode("div", _hoisted_16, _toDisplayString(__props.pillars[key].tips.element), 1)
              ]),
              _: 2
            }, 1024)
          ]))
        }), 128))
      ]),
      _createElementVNode("tr", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(ownerOrder), (key) => {
          return (_openBlock(), _createElementBlock("td", {
            key: key,
            class: "border px-3 py-3 align-middle"
          }, [
            _createElementVNode("p", null, _toDisplayString(_unref(t)("calculators.bazi.results.birthday-map.stem.god")), 1),
            _createVNode(AppTooltip, null, {
              trigger: _withCtx(() => [
                _createElementVNode("h4", {
                  class: "mb-0",
                  style: _normalizeStyle(`color: ${_unref(tenGods)[__props.pillars[key].god]['color']}`)
                }, _toDisplayString(__props.pillars[key].god), 5)
              ]),
              popper: _withCtx(() => [
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("h5", null, _toDisplayString(__props.pillars[key].labels.god), 1),
                  _createElementVNode("p", _hoisted_18, _toDisplayString(__props.pillars[key].tips.god), 1)
                ])
              ]),
              _: 2
            }, 1024)
          ]))
        }), 128))
      ])
    ])
  ]))
}
}

})